/**
 * Custom wrapper to invalidate RTK Query api tag cache
 * @param {*} queryFulfilled 
 * @param {*} dispatch 
 * @param {*} api 
 * @param {*} tags 
 */
export const invalidateAPITags = async (queryFulfilled, dispatch, api, tags) => {
  try {
    await queryFulfilled;
    dispatch(api.util.invalidateTags(tags)); // Invalidate the specified tags
  } catch (error) {
    console.error("Failed to invalidate tags:", error);
  }
};


export const groupByPeerProgramDate = (data) => {
  if(!data?.length) {
    return null;
  }
  const seen = new Set();
  const result = [];

  for (const item of data) {
    const key = `${item.peer_id}-${item.program_id}-${item.session_date}`;

    if (!seen.has(key)) {
      seen.add(key);
      result.push(item); // only push the first occurrence
    }
  }

  return result;
}

export const findCaseLoadByType = (caseloads, caseType) => {
  if(!caseloads?.length) return null;

  return caseloads.find(caseload => caseload.case_type === caseType);
}

export const getApptTrackerStepStatus = (stepId, steps) => {
  if(!stepId || !steps?.length ) {
    return false;
  }
  return steps.find(step => step.stepID === stepId);
}

export const normalizeUrl = (url) => {
  if (!url) return "";
  return url.startsWith("http://") || url.startsWith("https://")
    ? url
    : `http://${url}`;
};
